export default __webpack_public_path__ + "static/media/1_site_minder.86ccb62d.svg";